var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("h2", [_vm._v(_vm._s(_setup.props.status.name))]),
      _vm._v(" "),
      _c("div", { staticClass: "ul" }, [
        _c("div", { staticClass: "a" }, [_vm._v("Статус")]),
        _vm._v(" "),
        _c("div", { staticClass: "b" }, [
          _vm._v(_vm._s(_setup.props.actreward.status_name)),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ul" }, [
        _c("div", { staticClass: "a" }, [_vm._v("Тип выплаты")]),
        _vm._v(" "),
        _c("div", { staticClass: "b" }, [
          _vm._v(_vm._s(_setup.props.actreward.intent_title)),
        ]),
      ]),
      _vm._v(" "),
      "bank" == _setup.props.actreward.account.type
        ? _c("div", { staticClass: "ul" }, [
            _c("div", { staticClass: "a" }, [_vm._v("Ревизиты")]),
            _vm._v(" "),
            _c("div", { staticClass: "b" }, [
              _vm._v("Счет: " + _vm._s(_setup.props.actreward.account.anumber)),
              _c("br"),
              _vm._v("БИК: " + _vm._s(_setup.props.actreward.account.bik)),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "ul" }, [
        _c("div", { staticClass: "a" }, [_vm._v("Создана")]),
        _vm._v(" "),
        _c("div", { staticClass: "b" }, [
          _vm._v(_vm._s(_setup.dayjsFormat(_setup.props.actreward.ctime))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ul" }, [
        _c("div", { staticClass: "a" }, [_vm._v("Сумма")]),
        _vm._v(" "),
        _c("div", { staticClass: "b" }, [
          _vm._v(_vm._s(_setup.props.actreward.sum)),
        ]),
      ]),
      _vm._v(" "),
      _setup.props.actreward.comission
        ? _c("div", { staticClass: "ul" }, [
            _c("div", { staticClass: "a" }, [_vm._v("Комиссия")]),
            _vm._v(" "),
            _c("div", { staticClass: "b" }, [
              _vm._v(_vm._s(_setup.props.actreward.comission)),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("h2", [_vm._v("Подписанные документы")]),
      _vm._v(" "),
      _vm._l(_setup.props.actreward.docs, function (ob) {
        return _c("div", { key: ob.key }, [
          _c("a", { attrs: { href: ob.url, target: "_blank" } }, [
            _vm._v(_vm._s(ob.type_str)),
          ]),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }